import { entrySplitApi as api } from "../entryApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    questionScenesControllerCreate: build.mutation<
      QuestionScenesControllerCreateApiResponse,
      QuestionScenesControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/question-scenes`,
        method: "POST",
        body: queryArg.createQuestionSceneDto,
      }),
    }),
    questionScenesControllerList: build.query<
      QuestionScenesControllerListApiResponse,
      QuestionScenesControllerListApiArg
    >({
      query: (queryArg) => ({
        url: `/question-scenes/list`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          orderBy: queryArg.orderBy,
          sortOrder: queryArg.sortOrder,
          keyword: queryArg.keyword,
        },
      }),
    }),
    questionScenesControllerFindAll: build.query<
      QuestionScenesControllerFindAllApiResponse,
      QuestionScenesControllerFindAllApiArg
    >({
      query: () => ({ url: `/question-scenes/all` }),
    }),
    questionScenesControllerFindOne: build.query<
      QuestionScenesControllerFindOneApiResponse,
      QuestionScenesControllerFindOneApiArg
    >({
      query: (queryArg) => ({ url: `/question-scenes/${queryArg.id}` }),
    }),
    questionScenesControllerUpdate: build.mutation<
      QuestionScenesControllerUpdateApiResponse,
      QuestionScenesControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/question-scenes/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.createQuestionSceneDto,
      }),
    }),
    questionScenesControllerRemove: build.mutation<
      QuestionScenesControllerRemoveApiResponse,
      QuestionScenesControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/question-scenes/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    questionScenesControllerUpdateActiveStatus: build.mutation<
      QuestionScenesControllerUpdateActiveStatusApiResponse,
      QuestionScenesControllerUpdateActiveStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/question-scenes/${queryArg.id}/active`,
        method: "PATCH",
        body: queryArg.updateQuestionSceneActiveDto,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as combinedApi };
export type QuestionScenesControllerCreateApiResponse = unknown;
export type QuestionScenesControllerCreateApiArg = {
  createQuestionSceneDto: CreateQuestionSceneDto;
};
export type QuestionScenesControllerListApiResponse = /** status 200  */ {
  data?: QuestionSceneDto[];
} & {
  meta?: {
    total?: number;
    lastPage?: number;
    currentPage?: number;
    perPage?: number;
    prev?: number;
    next?: number;
  };
};
export type QuestionScenesControllerListApiArg = {
  page: number;
  pageSize: number;
  orderBy?: string;
  sortOrder?: "ASC" | "DESC";
  keyword?: string;
};
export type QuestionScenesControllerFindAllApiResponse =
  /** status 200  */ QuestionSceneDto[];
export type QuestionScenesControllerFindAllApiArg = void;
export type QuestionScenesControllerFindOneApiResponse =
  /** status 200  */ QuestionSceneDto;
export type QuestionScenesControllerFindOneApiArg = {
  id: string;
};
export type QuestionScenesControllerUpdateApiResponse = unknown;
export type QuestionScenesControllerUpdateApiArg = {
  id: string;
  createQuestionSceneDto: CreateQuestionSceneDto;
};
export type QuestionScenesControllerRemoveApiResponse = unknown;
export type QuestionScenesControllerRemoveApiArg = {
  id: string;
};
export type QuestionScenesControllerUpdateActiveStatusApiResponse = unknown;
export type QuestionScenesControllerUpdateActiveStatusApiArg = {
  id: string;
  updateQuestionSceneActiveDto: UpdateQuestionSceneActiveDto;
};
export type CreateQuestionOptionDto = {
  id?: string;
  cnName?: string;
  enName?: string;
  cntName: string;
  optionType:
    | "decisive"
    | "analytical"
    | "creative"
    | "idealistic"
    | "controlling"
    | "affairs"
    | "feel"
    | "interpersonal";
  sceneId?: string;
};
export type CreateQuestionSceneDto = {
  cnName?: string;
  cnDescription?: string;
  enName?: string;
  enDescription?: string;
  cntName: string;
  cntDescription?: string;
  resultTemplate: string;
  starterTemplate?: string;
  options?: CreateQuestionOptionDto[];
};
export type QuestionOptionType =
  | "decisive"
  | "analytical"
  | "creative"
  | "idealistic"
  | "controlling"
  | "affairs"
  | "feel"
  | "interpersonal";
export type QuestionOptionDto = {
  id: string;
  cnName?: string;
  enName?: string;
  cntName: string;
  optionType: QuestionOptionType;
  sceneId: string;
  sceneCnName?: string;
  sceneCntName?: string;
  sceneEnName?: string;
  createdAt: string;
  updatedAt: string;
};
export type QuestionSceneDto = {
  id: string;
  name: string;
  description: string;
  cntName: string;
  cntDescription: string;
  cnName?: string;
  cnDescription?: string;
  enName?: string;
  enDescription?: string;
  resultTemplate: string;
  starterTemplate?: string;
  createdAt: string;
  updatedAt: string;
  questionOptions: {
    options: QuestionOptionDto[];
  }[];
  active: boolean;
};
export type UpdateQuestionSceneActiveDto = {
  active: boolean;
};
export const {
  useQuestionScenesControllerCreateMutation,
  useQuestionScenesControllerListQuery,
  useLazyQuestionScenesControllerListQuery,
  useQuestionScenesControllerFindAllQuery,
  useLazyQuestionScenesControllerFindAllQuery,
  useQuestionScenesControllerFindOneQuery,
  useLazyQuestionScenesControllerFindOneQuery,
  useQuestionScenesControllerUpdateMutation,
  useQuestionScenesControllerRemoveMutation,
  useQuestionScenesControllerUpdateActiveStatusMutation,
} = injectedRtkApi;
